import { type Errors, type KybDraft } from '~/lib/kyb';
import { NIGERIAN_STATES } from '~/lib/nigeria';
import { Field, SectionCard, Select, TextInput, TwoCol } from './Primitives';

export function AddressStep({
  draft,
  errors,
  update,
}: {
  draft: KybDraft;
  errors: Errors;
  update: (patch: Partial<KybDraft>) => void;
}): JSX.Element {
  return (
    <SectionCard
      title="Operating address"
      description="Where the business operates from day to day. Not a PO Box."
    >
      <div className="flex flex-col gap-4">
        <Field label="Street address" error={errors.addressLine}>
          <TextInput
            value={draft.addressLine}
            onChange={(v) => update({ addressLine: v })}
            autoComplete="street-address"
            placeholder="12 Admiralty Way"
            invalid={!!errors.addressLine}
          />
        </Field>

        <TwoCol>
          <Field label="City" error={errors.city}>
            <TextInput
              value={draft.city}
              onChange={(v) => update({ city: v })}
              autoComplete="address-level2"
              placeholder="Lekki"
              invalid={!!errors.city}
            />
          </Field>
          <Field label="State" error={errors.state}>
            <Select<string>
              value={draft.state}
              onChange={(v) => update({ state: v })}
              placeholder="Choose a state"
              invalid={!!errors.state}
              options={NIGERIAN_STATES.map((s) => ({ value: s, label: s }))}
            />
          </Field>
        </TwoCol>

        <TwoCol>
          <Field label="Contact phone" error={errors.contactPhone}>
            <TextInput
              value={draft.contactPhone}
              onChange={(v) => update({ contactPhone: v })}
              type="tel"
              inputMode="tel"
              autoComplete="tel"
              placeholder="+2348012345678"
              invalid={!!errors.contactPhone}
            />
          </Field>
          <Field label="Contact email" error={errors.contactEmail}>
            <TextInput
              value={draft.contactEmail}
              onChange={(v) => update({ contactEmail: v })}
              type="email"
              inputMode="email"
              autoComplete="email"
              placeholder="ops@acme.ng"
              invalid={!!errors.contactEmail}
            />
          </Field>
        </TwoCol>
      </div>
    </SectionCard>
  );
}
